import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const TermsAndConditionsModal = ({ open, onClose, type, data, onSave }) => {
  const [details, setDetails] = useState("");

  useEffect(() => {
    setDetails(data?.details || "");
  }, [data]);

  const handleSave = () => {
    if (details.trim()) {
      onSave(details);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          backgroundColor: "#C0BFFF",
          mb: 2,
          fontSize: { xs: "12px", sm: "13px", md: "15px" },
        }}
      >
        {type}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          multiline
          fullWidth
          sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
          minRows={6}
          value={details}
          InputLabelProps={{
            className: "mulish",
            sx: {
              color: "#545454",
              fontWeight: 400,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              paddingX: "7px",
            },
          }}
          InputProps={{
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
          onChange={(e) => setDetails(e.target.value)}
          placeholder="Enter Terms & Conditions"
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
          variant="contained"
          fullWidth
          onClick={handleSave}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsAndConditionsModal;
